import Card from "components/card";
import React, { useEffect, useState, useCallback } from "react";
import RolesDataTable from "./components/RolesDataTable";
import Loader from "components/Loader";
import { Role } from "types";
import api from "api/axios";
import { handleAxiosAndCaughtError } from "utils";
import { useTranslation } from "react-i18next";

const Roles = () => {
  const { t } = useTranslation();
  const [roles, setRoles] = useState<Role[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRoles = useCallback(async (signal?: AbortSignal) => {
    setLoading(true);
    setError(null);
    try {
      // TODO: temporary for backward compatibility
      const resp = await api.get<{ total: number; items: Role[] }>(
        `/groups`,
        {
          params: { take: 999, skip: 0 },
          ...(signal instanceof AbortSignal ? { signal } : {}),
        }
      );

      setRoles(resp.data.items);
    } catch (err: any) {
      if (signal?.aborted || err.name === "CanceledError") {
        return; // Aborted
      }
      setError(t("roles.failedToFetch"));
      handleAxiosAndCaughtError(err);
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchRoles(abortController.signal);
    return () => abortController.abort();
  }, [fetchRoles]);

  return (
    <Card extra={" relative w-full  h-[80vh] md:mt-3 mt-12 px-6"}>
      {loading ? (
        <Loader
          txt={t("roles.loadingRoles")}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ) : error ? (
        <div
          className="absolute left-1/2 top-1/2 flex -translate-x-1/2
        -translate-y-1/2 flex-col items-center justify-center py-10
         "
        >
          <span className="mb-4 text-red-500">{error}</span>
          <button
            className="rounded bg-brand-500 px-4 py-2 text-white transition hover:bg-brand-600"
            onClick={() => fetchRoles()}
          >
            {t("common.retry")}
          </button>
        </div>
      ) : (
        <RolesDataTable fetchRoles={fetchRoles} tableData={roles || []} />
      )}
    </Card>
  );
};

export default Roles;
